export var IntelligentPhotoCaptureEstimatorCaptureMode;
(function (IntelligentPhotoCaptureEstimatorCaptureMode) {
    IntelligentPhotoCaptureEstimatorCaptureMode["BULK_PHOTOS"] = "Upload Photos";
    IntelligentPhotoCaptureEstimatorCaptureMode["TAKE_PHOTOS"] = "Take Photos";
    IntelligentPhotoCaptureEstimatorCaptureMode["UPLOAD_FILES"] = "Upload Files";
})(IntelligentPhotoCaptureEstimatorCaptureMode || (IntelligentPhotoCaptureEstimatorCaptureMode = {}));
//# sourceMappingURL=IntelligentPhotoCaptureEstimatorCaptureMode.js.map